import React, {useState, useEffect} from 'react';
import {Controller, useForm} from 'react-hook-form';

import {
  Button,
  CircularProgress,
  TextField,
  Grid,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Checkbox,
  ListItemText
} from '@material-ui/core';

import {
  MuiPickersUtilsProvider,
  DatePicker,
  DateTimePicker,
  TimePicker,
} from '@material-ui/pickers';
import jMoment from 'moment-jalaali';
import JalaliUtils from '@date-io/jalaali';
import {
  convertPersianDigit2English,
  checkMatchMedia,
  OrderTransportationType,
  translate,
  removeEmptyValueObject,
  // removeEmptyValueObject,
  // flattenObject,
} from './helpers';
import {Status as OrderStatus} from '../pages/orders/interfaces';
import {
  OrderBundleStatus,
  Status as BundleStatus,
} from '../pages/bundles/interfaces';
import {Status as CenterStatus} from '../pages/centers/interfaces';
import {UserRole} from '../pages/users/interfaces';
import {Status as ParcelsState} from '../pages/parcels/interfaces';
import {Category} from '../pages/products/interfaces';
import clsx from 'clsx';
import {createStyles, makeStyles, Theme} from '@material-ui/core/styles';
import {flattenObject} from 'client-sdk/src/helpers';

jMoment.loadPersian({dialect: 'persian-modern', usePersianDigits: true});

export type State = {
  classes: Function;
};
export type Props = {
  filters: FilterInterface[];
  onFilter: any; //ToDo
  baseFilter: BaseFilter;
  filterValues: any;
  mainFiltersCount: number;
  isOpenFilters: boolean;
  setIsOpenFilter: (type:boolean) => void;
};

export type BaseFilter = {
  type:
    | 'input'
    | 'select'
    | 'checkbox'
    | 'date-picker'
    | 'number'
    | 'time-picker'
    | 'date-picker-time';
  id: string;
  placeholder: string;
};

export type FilterInterface = {
  type:
    | 'input'
    | 'select'
    | 'checkbox'
    | 'date-picker'
    | 'number'
    | 'time-picker'
    | 'date-picker-time';
  id: string;
  label: string;
  placeholder?: string;
  data?:
    | OrderStatus[]
    | BundleStatus[]
    | UserRole[]
    | CenterStatus[]
    | ParcelsState[]
    | OrderTransportationType[]
    | OrderBundleStatus[]
    | Category[];
  translateType?:
    | 'Order'
    | 'Category'
    | 'Bundle'
    | 'UserRole'
    | 'CenterStatus'
    | 'ParcelsStatus'
    | 'FleetType'
    | 'EmploymentStatus'
    | 'VehicleType'
    | 'TransactionType'
    | 'TPL'
    | 'OrderBundleStatus'
    | 'FleetStatus'
    | 'DeliveryType';
  icon?: any;
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '& .MuiInput-underline::before': {
        borderBottom: '1px solid #d8d8d8 !important',
      },
      '& .MuiSelect-root': {
        fontSize: '1rem !important',
      },
    },
    container: {
      '@media (max-width: 768px)': {
        width: '100%',
      },
    },
    magnifyIcon: {
      transform: 'rotate(-90deg)',
    },
    searchBox: {
      width: '100%',
      display: 'flex',
      position: 'relative',
      backgroundColor: theme.palette.common.white,
      borderRadius: '4px',
      padding: '1px 0',
      '@media (max-width: 480px)': {
        height: '50px',
        width: '100%',
        // marginLeft: '80px',
      },
    },
    iconButton: {
      padding: 8,
      marginRight: '10px',
      position: 'relative',
      '&:before': {
        content: '""',
        position: 'absolute',
        width: '1px',
        height: '30px',
        top: '4px',
        left: '-9px',
        backgroundColor: '#EDF1F4',
      },
    },
    iconButton1: {
      padding: 8,
      marginRight: '10px',
      position: 'relative',
    },
    filterOpen: {
      display: 'block',
    },
    filterClose: {
      display: 'none',
    },
    closeIcon: {
      color: '#EC4040',
      backgroundColor: '#F7B3B3',
      borderRadius: '5px',
      padding: '5px',
    },
    textArea: {
      width: '100%',
    },
    filterBox: {
      backgroundColor: '#fff',
      width: '100%',
      // marginTop: '30px',
      top: '34px',
      right: 0,
      borderRadius: '0  0 4px  4px',
      padding: '16px 0',
      boxSizing: 'border-box',
      zIndex: 10,
    },
    textInput: {
      color: '#8a8a8a',
      '& input, .MuiSelect-root': {
        padding: '6px 0 12px !important',
      },

      // '& .MuiInput-underline::before': {
      //   borderBottom: '1px solid #d8d8d8 !important',
      // },
    },
    inputWrapper: {
      flex: 7,
    },
    icon: {
      color: '#8a8a8a',
    },
  })
);

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

function Filter(props: Props) {
  const [checkboxValue, setCheckboxValue] = useState([] as any[]);
  const classes = useStyles();
  const [init, setInit] = useState({} as any);
  const {filters, onFilter, baseFilter, filterValues,setIsOpenFilter, mainFiltersCount} = props;
  const [openFilterBox, setOpenFilterBox] = React.useState(false);

  const {register, handleSubmit, control, setValue, getValues, watch, reset} =
    useForm<any>();

  useEffect(() => {
    props.filters.map((item: any) => {
      if (item.type === 'date-picker-time' || item.type === 'date-picker') {
        register({name: item.id}, {required: false});
      }
    });
  }, [register]);

  useEffect(() => {
    props.filters.map((item: any) => {
      if(item.type === 'checkbox' && filterValues[item.id]) {
        setCheckboxValue(filterValues[item.id].split(","))
      }
      setValue(item.id, filterValues[item.id]);
    });
  }, [props.isOpenFilters]);

  const handleChange = (event: any) => {
    setCheckboxValue(event.target.value);
  };
  const values = flattenObject(getValues());

  const renderFromItems = (filters: Record<string, any>[], props: any) => {
    return filters.map(
      (
        item: any, //todo type
        index: number
      ) => (
        <>
          {item.type === 'input' && (
            <Grid item lg={2} xs={6}>
              <TextField
                variant="outlined"
                inputRef={register({required: false})}
                name={item.id}
                label={item.label}
                fullWidth
                defaultValue={null}
              />
            </Grid>
          )}

          {item.type === 'number' && (
            <Grid item lg={2} xs={6}>
              <TextField
                variant="outlined"
                inputRef={register({required: false})}
                name={item.id}
                label={item.label}
                type={item.type}
                fullWidth
                defaultValue={null}
              />
            </Grid>
          )}

          {item.type === 'date-picker' && (
            <Grid item lg={2} xs={6}>
              <Controller
                style={{width: '100%'}}
                name={item.id}
                control={control}
                rules={{required: false}}
                render={() => (
                  <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
                    <DatePicker
                      inputVariant="outlined"
                      inputRef={register({required: false})}
                      fullWidth
                      autoOk
                      variant="inline"
                      label={item.label}
                      format="YYYY/MM/DD"
                      clearable
                      okLabel="تأیید"
                      cancelLabel="لغو"
                      clearLabel="پاک کردن"
                      labelFunc={date =>
                        date?.isValid() ? date.format('jYYYY/jMM/jDD') : ''
                      }
                      value={watch(`${item.id}`) || null}
                      name={item.id}
                      id={item.id}
                      onChange={value => {
                        return setValue(
                          item.id,
                          value &&
                            convertPersianDigit2English(
                              value.format('YYYY-MM-DD')
                            )
                        );
                      }}
                    />
                  </MuiPickersUtilsProvider>
                )}
              />
            </Grid>
          )}

          {item.type === 'time-picker' && (
            <Grid item lg={2} xs={6}>
              <Controller
                style={{width: '100%'}}
                name={item.id}
                control={control}
                rules={{required: false}}
                render={() => (
                  <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
                    <TimePicker
                      inputVariant="outlined"
                      fullWidth
                      label={item.label}
                      variant="inline"
                      ampm={false}
                      format="HH:mm"
                      autoOk
                      clearable
                      labelFunc={date =>
                        date?.isValid() ? date.format('HH:mm') : ''
                      }
                      value={watch(`${item.id}`) || null}
                      name={item.id}
                      id={item.id}
                      onChange={value => {
                        return setValue(
                          item.id,
                          value &&
                            convertPersianDigit2English(
                              value.format('jYYYY/jMM/jDD HH:mm')
                            )
                        );
                      }}
                    />
                  </MuiPickersUtilsProvider>
                )}
              />
            </Grid>
          )}

          {item.type === 'date-picker-time' && (
            <Grid item lg={2} xs={6}>
              <Controller
                style={{width: '100%'}}
                name={item.id}
                control={control}
                rules={{required: false}}
                render={() => (
                  <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
                    <DateTimePicker
                      inputVariant="outlined"
                      inputRef={register({required: false})}
                      fullWidth
                      label={item.label}
                      variant="inline"
                      format="YYYY/MM/DD HH:mm"
                      autoOk
                      clearable
                      okLabel="تأیید"
                      cancelLabel="لغو"
                      clearLabel="پاک کردن"
                      labelFunc={date =>
                        date?.isValid()
                          ? date.format('jYYYY/jMM/jDD HH:mm')
                          : ''
                      }
                      value={watch(`${item.id}`) || null}
                      name={item.id}
                      id={item.id}
                      onChange={value => {
                        return setValue(
                          item.id,
                          value && convertPersianDigit2English(value.format())
                        );
                      }}
                    />
                  </MuiPickersUtilsProvider>
                )}
              />
            </Grid>
          )}


          {item.type === 'select' && (
            <Grid item lg={2} xs={6}>
              <FormControl style={{width: '100%'}}>
                <InputLabel htmlFor={item.id} className='select-label'>{item.label}</InputLabel>
                <Controller
                  name={item.id}
                  control={control}
                  rules={{required: false}}
                  render={({onChange, value}) => (
                    <Select
                      variant='outlined'
                      inputRef={register({required: false})}
                      fullWidth
                      name={item.id}
                      label={item.label}
                      onChange={e => {
                        setValue(item.id, e.target.value);
                      }}
                      value={values[item.id] || ''}
                      inputProps={{
                        name: item.id,
                        id: item.id,
                      }}
                    >
                      <MenuItem aria-label="None" value="" />
                      {item.data.map((itemD: any, index: number) => (
                        <MenuItem value={itemD} key={index}>
                          {item.translateType === 'Order'
                            ? translate(itemD, 'order')
                            : item.translateType === 'UserRole'
                            ? translate(itemD, 'user')
                            : item.translateType === 'ParcelsStatus'
                            ? translate(itemD, 'parcel')
                            : item.translateType === 'FleetStatus'
                            ? translate(itemD, 'fleet')
                            : item.translateType === 'VehicleType'
                            ? translate(itemD)
                            : item.translateType === 'TransactionType'
                            ? translate(itemD)
                            : item.translateType === 'TPL'
                            ? translate(itemD, 'TPL')
                            : item.translateType === 'OrderBundleStatus'
                            ? translate(itemD, 'order')
                            : item.translateType === 'EmploymentStatus'
                            ? translate(itemD, 'driver')
                            : item.translateType === 'COD'
                            ? translate(nameSelect,'cod')
                            : item.translateType === 'DeliveryType'
                            ? translate(itemD, 'common')
                            : translate(itemD, item.translateType)}
                        </MenuItem>
                      ))}
                    </Select>
                  )}
                />
              </FormControl>
            </Grid>
          )}
          {item.type === 'checkbox' && (
            <Grid item lg={2} xs={6}>
              <FormControl style={{width: '100%'}}>
                <InputLabel className='select-label' id={item.id}>{item.label}</InputLabel>
                <Controller
                  name={item.id}
                  control={control}
                  rules={{required: false}}
                  label={item.label}
                  render={({onChange, value}) => (
                    <Select
                      variant='outlined'
                      inputRef={register({required: false})}
                      labelId={item.id}
                      label={item.label}
                      id={item.id}
                      multiple
                      onChange={e => {
                        handleChange(e);
                        setValue(item.id, e.target.value);
                      }}
                      value={values[item.id]?.split(',') || []}
                      // input={<TextField variant='outlined'/>}
                      name={item.id}
                      inputProps={{
                        name: item.id,
                        id: item.id,
                      }}
                      renderValue={(selected: any) => {
                        const nameSelectedItem = item.data.filter(
                          (status: any) => {
                            return selected.includes(status);
                          }
                        );

                        return nameSelectedItem
                          .map((nameSelect: any) =>
                            item.translateType === 'Order'
                              ? translate(nameSelect, 'order')
                              : item.translateType === 'UserRole'
                              ? translate(nameSelect, 'user')
                              : item.translateType === 'Category'
                              ? nameSelect
                              : item.translateType === 'CenterStatus'
                              ? translate(nameSelect, 'center')
                              : item.translateType === 'ParcelsStatus'
                              ? translate(nameSelect, 'parcel')
                              : item.translateType === 'TPL'
                              ? translate(nameSelect, 'TPL')
                              : item.translateType === 'OrderBundleStatus'
                              ? translate(nameSelect, 'order')
                              : item.translateType === 'FleetType'
                              ? translate(nameSelect, 'fleet')
                              : item.translateType === 'COD'
                              ? translate(nameSelect,'cod')
                              : item.translateType === 'Invoice'
                              ? translate(nameSelect,'invoice')
                              : translate(nameSelect, item.translateType)
                          )
                          .join(',');
                      }}
                      MenuProps={MenuProps}
                    >
                      {item.data.map((itemD: any) => (
                        <MenuItem key={itemD} value={itemD}>
                          <Checkbox
                            checked={
                              checkboxValue.indexOf(itemD) > -1 
                            }
                          />
                          <ListItemText
                            primary={
                              // Todo
                              item.translateType === 'Order'
                                ? translate(itemD, 'order')
                                : item.translateType === 'UserRole'
                                ? translate(itemD, 'user')
                                : item.translateType === 'Category'
                                ? itemD
                                : item.translateType === 'CenterStatus'
                                ? translate(itemD, 'center')
                                : item.translateType === 'ParcelsStatus'
                                ? translate(itemD, 'parcel')
                                : item.translateType === 'TPL'
                                ? translate(itemD, 'TPL')
                                : item.translateType === 'OrderBundleStatus'
                                ? translate(itemD, 'order')
                                : item.translateType === 'FleetType'
                                ? translate(itemD, 'fleet')
                                : item.translateType === 'COD'
                                ? translate(itemD,'cod')
                                : item.translateType === 'Invoice'
                                ? translate(itemD,'invoice')
                                : translate(itemD, item.translateType)
                            }
                          />
                        </MenuItem>
                      ))}
                    </Select>
                  )}
                />
              </FormControl>
            </Grid>
          )}
        </>
      )
    );
  };

  const onSubmit = (data: any) => {
    props.onFilter(data);
    setOpenFilterBox(false);
  };

  return (
    <>
    {props.isOpenFilters ? <div className={classes.container}>
      <Grid item xs={12}>
        <div className={classes.searchBox}>
          <form onSubmit={handleSubmit(onSubmit)} className='w-100'>
            <div
              className={clsx(classes.filterBox, {
                [classes.filterOpen]: openFilterBox,
              })}
            >
              <Grid
                container
                spacing={checkMatchMedia('(max-width: 768px)') ? 1 : 3}
              >
                {renderFromItems(filters, props)}
                <Grid
                  xs={6}
                  lg={2}
                  item
                  style={{
                    display: 'flex',
                    alignItems: "center",
                    // marginTop: '20px',
                    // marginBottom: '20px',
                    marginRight: "auto"
                  }}
                >
                    <Button
                      fullWidth
                      style={{marginLeft: '10px', width: "20%"}}
                      variant="contained"
                      size="medium"
                      color="primary"
                      type="button"
                      onClick={() => {
                        reset({});
                        onFilter({});
                        setCheckboxValue([]);
                        setIsOpenFilter(false)
                      }}
                      disabled={
                        Object.keys(
                          flattenObject(removeEmptyValueObject(watch()))
                        ).length === 0
                      }
                    >
                      {'لغو'}
                    </Button>
                    <Button
                      fullWidth
                      type="submit"
                      style={{width: "80%"}}
                      variant="contained"
                      color="primary"
                      autoFocus
                      size="medium"
                      data-cy="search"
                      disabled={
                        Object.keys(
                          flattenObject(removeEmptyValueObject(watch()))
                        ).length === 0
                      }
                    >
                      {'اعمال فیلتر'}
                      {false && <CircularProgress size={24} />}
                    </Button>
                </Grid>
              </Grid>
            </div>
          </form>
        </div>
      </Grid>
    </div> : <></>}
    </>
  );
}

export default Filter;
